import React from 'react';
import { BriefcaseIcon, DollarSignIcon, UsersIcon, UserCheckIcon } from 'lucide-react';
export const KPISection = () => {
  return <div className="mb-8" data-id="element-160">
      <div className="flex items-center justify-between mb-4" data-id="element-161">
        <h2 className="text-lg font-semibold text-gray-800" data-id="element-162">
          Key Performance Indicators
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-163">
        <KPICard icon={<BriefcaseIcon className="text-blue-500" data-id="element-165" />} title="Total Jobs" value="1,284" details={[{
        label: 'Posted',
        value: '856'
      }, {
        label: 'Completed',
        value: '428'
      }]} color="blue" data-id="element-164" />
        <KPICard icon={<DollarSignIcon className="text-green-500" data-id="element-167" />} title="Revenue" value="$28,429" details={[{
        label: 'Today',
        value: '$2,850'
      }, {
        label: 'Week',
        value: '$12,380'
      }, {
        label: 'Month',
        value: '$28,429'
      }]} color="green" data-id="element-166" />
        <KPICard icon={<UsersIcon className="text-purple-500" data-id="element-169" />} title="Active Users" value="3,624" color="purple" data-id="element-168" />
        <KPICard icon={<UserCheckIcon className="text-orange-500" data-id="element-171" />} title="Active Pros" value="523" color="orange" data-id="element-170" />
      </div>
    </div>;
};
const KPICard = ({
  icon,
  title,
  value,
  details,
  color = 'blue'
}) => {
  const colorClasses = {
    blue: 'bg-blue-50 text-blue-500',
    green: 'bg-green-50 text-green-500',
    purple: 'bg-purple-50 text-purple-500',
    orange: 'bg-orange-50 text-orange-500'
  };
  return <div className="bg-white rounded-lg shadow p-5 border border-gray-100" data-id="element-172">
      <div className="flex items-center mb-4" data-id="element-173">
        <div className={`p-2 rounded-md ${colorClasses[color]}`} data-id="element-174">{icon}</div>
        <div className="ml-3" data-id="element-175">
          <h3 className="text-sm font-medium text-gray-500" data-id="element-176">{title}</h3>
          <p className="text-2xl font-semibold text-gray-800" data-id="element-177">{value}</p>
        </div>
      </div>
      {details && <div className="space-y-2" data-id="element-178">
          {details.map((detail, index) => <div key={index} className="flex justify-between items-center" data-id="element-179">
              <span className="text-sm text-gray-500" data-id="element-180">{detail.label}</span>
              <span className="text-sm font-medium text-gray-700" data-id="element-181">
                {detail.value}
              </span>
            </div>)}
        </div>}
    </div>;
};